import { eligibleToPromoteProjectActivity } from '../../project-model';
import { useProject } from '../../project-hooks/useProject';
import { useSelector } from 'react-redux';
import { getStatsForRecentTransactionsForProject } from '../../projects-reducer';
import { useFeature } from '../../../components/hooks/isFeatureEnabled';
import { STREAM_ON_PROJECT } from '../../../constants/features/constants';

export const useNumberOfRecentTransactions = () => {
    const project = useProject();
    const recentTransactionStats = useSelector((state) => getStatsForRecentTransactionsForProject(state, project?.id));
    const streamOnProject = useFeature(STREAM_ON_PROJECT);
    if (
        eligibleToPromoteProjectActivity({
            numberOfRecentTransactions: recentTransactionStats?.numberOfRecentTransactions,
            streamOnProject,
            project,
        })
    ) {
        return {
            eligible: true,
            numberOfRecentTransactions: recentTransactionStats?.numberOfRecentTransactions,
        };
    }

    return {
        eligible: false,
        numberOfRecentTransactions: null,
    };
};
